import { FC, PropsWithChildren, ReactNode, createContext } from "react";
import { Settings } from "../types/settings";
import useSettingsProvider from "../hooks/useSettingsProvider";
import { LoadingAnimation } from "@/components/LoadingAnimation";

interface ISettingsProviderProps extends PropsWithChildren {
	debugSettings?: Settings;
}

const SettingsProvider: FC<ISettingsProviderProps> = ({ 
	children, debugSettings 
}) => {
	
	if (debugSettings != undefined) {
		return <SettingsProviderContext.Provider value={debugSettings}>
			{children}
		</SettingsProviderContext.Provider>
	}

  const { settings } = useSettingsProvider();
	console.debug(settings);


	return <SettingsProviderContext.Provider value={settings.privateData ?? settings.publicData}>
    {!settings.loaded && settings.isFetching && <LoadingAnimation/>}
		{settings.loaded && !settings.error && children}
		{settings.loaded && settings.error && <div>Error fetching settings</div>}
	</SettingsProviderContext.Provider>
}

export default SettingsProvider;

export const SettingsProviderContext = createContext<null | Settings>(null);
